import React, {
  useRef,
  useEffect,
  forwardRef,
  useImperativeHandle,
} from "react";
import axiosInstance from "../../../../axios";
import VideoIFrame from "../../../Dashboard/profileManager/VideoPreview";

const ChapterVideo = forwardRef((props, ref) => {
  const videoRef = useRef();
  useEffect(() => {
    const currentTimeValue = Number(props?.details?.progress?.durationCompleted);

    if (
      videoRef.current !== undefined &&
      videoRef.current !== null &&
      !isNaN(currentTimeValue) &&
      isFinite(currentTimeValue)
    ) {
      videoRef.current.currentTime = currentTimeValue;
    }
  }, [props?.details?.progress]);


  const handleProgress = async (duration, forceFinished) => {
    try {
      const response = await axiosInstance.post(
        "course/progress/update",
        JSON.stringify({
          courseDetailId: props?.details?.courseDetailId,
          fileId: props?.details?.id,
          durationCompleted: duration,
          isFinished: forceFinished !== undefined ? forceFinished : props?.checked,
        }),
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      //console.log(response);
    } catch (error) {
      console.error("Error updating progress:", error);
    }
  };

  window.addEventListener("beforeunload", (event) => {
    event.preventDefault();
    const duration = videoRef?.current?.currentTime;
    const videoDuration = duration.toFixed();
    if (props?.checked === false) {
      handleProgress(videoDuration);
    }
  });

  useImperativeHandle(ref, () => ({
    acknowledgeCompleteChapter() {
      if (props?.checked === true) {
        const videoDuration = props?.details?.duration;
        handleProgress(videoDuration);
      } else if (props?.checked === false) {
        const duration = 0;

        handleProgress(duration);
      }
    },
  }));

  const PauseDurationHandler = () => {
    const duration = videoRef?.current?.currentTime;
    //console.log("Duration on pause:", duration);  
    const videoDuration = duration?.toFixed();

    if (props?.checked == false) {
      handleProgress(videoDuration);
    }
  };

  const handleEnded = () => {
    const videoDuration = props?.details?.duration;
    handleProgress(videoDuration, true);
    if (props.onVideoEnded) {
      props.onVideoEnded();
    }
  };

  useEffect(() => {
    document.addEventListener(
      "play",
      function (e) {
        var videos = document.getElementsByTagName("video");
        for (var i = 0, len = videos.length; i < len; i++) {
          if (videos[i] != e.target) {
            videos[i].pause();
          }
        }
      },
      true
    );
  });

  return (
    <>
          <div className="">
            {props.videoLink ? (
              <VideoIFrame url={props.videoLink} />
            ) : (
              <div className="">
                <video
                  controls
                  ref={videoRef}
                  onPause={PauseDurationHandler}
                  onEnded={handleEnded}
                  className="h-[400px] w-full rounded-lg shadow-lg"
                >
                  <source src={props.data} type="video/mp4" />
                </video>
              </div>
            )}
          </div>
        

    </>
  );
});
export default ChapterVideo;
